export default "__VITE_PUBLIC_ASSET__9baca142__"